import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const add_email_string = (emailList) => {
  const normalizedList = (emailList || []).map((item) => {
    if (typeof item !== "string") return item;
    const trimmed = item.trim();
    if (trimmed === "") return trimmed;
    const parts = trimmed.split(",").map((p) => p.trim());
    if (parts.length < 6) {
      parts.push("1");
    } else {
      const lastIndex = parts.length - 1;
      if (!parts[lastIndex]) parts[lastIndex] = "1";
    }
    return parts.join(",");
  });

  return api.post(`${ApiEndpointConstants.ADDMANYEMAIL}`, normalizedList);
};

// ["邮箱账号,邮箱密码,邮箱密钥,端口号,smtp地址,邮箱状态",]
